import React, { useState } from 'react'
import { Dialog, TextField, Button, Frame, Heading } from 'components'
import { useHistory, deleteUser } from 'utils'

const SubsciberDelete = ({ user, setUserNull, setSnackMessage }) => {
  const history = useHistory()
  const [alertOpen, setAlertOpen] = useState()
  const [password, setPassword] = useState('')

  return (
    <Frame maxWidth="xs" user={user}>
      <Heading>Delete your account?</Heading>

      <Dialog
        open={!!alertOpen}
        onClose={() => setAlertOpen(null)}
        title="Are you sure?"
        body="Are you sure you want to delete your account?"
        secondaryText="Cancel"
        onSecondaryClick={() => setAlertOpen(null)}
        confirmText="Delete Account"
        onClick={() => {
          setAlertOpen(null)
          deleteUser(password).then(() => {
            history.push('/')
            setUserNull()
            setSnackMessage('Your account has been successfully deleted')
          })
        }}
      />

      <TextField
        required
        name="password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        label="Current Password"
      />

      <Button
        disabled={password.length === 0}
        type="submit"
        onClick={() => {
          if (password.length > 0) {
            setAlertOpen(true)
          }
        }}
      >
        Delete
      </Button>
    </Frame>
  )
}

export default SubsciberDelete
